<template>
  <Dialog
    :backgroundImage="null"
    width="80%"
    background="rgba(255, 255, 255, 0.2)"
    titleAlign="center"
    title=""
    customClass="confirm-pay-dialog"
    :hideCloseBtn="true"
    :visible="renderData.visible"
  >
    <div class="height-all pay-result flex-column">
      <div v-if="state == 5" class="fail">
        <div class="text">未查询到您的支付成功状态</div>
        <div class="text">如已付款，请点击“我已付款</div>
        <div class="text">我们将尽快核实并激活您的付款状态</div>
        <div class="btn-box">
          <div class="btn" @click="checkPay">
            <template v-if="!isLoading">
              {{ $$t("payment.i_have_paid") }}
            </template>
            <div v-else class="loading-placeholder flex-center">
              <img src="@/assets/img/loading-mini-white-3x.png" alt="" />
            </div>
          </div>
          <div class="btn" @click="closeDialog">
            {{ $$t("payment.not_paid") }}
          </div>
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  reactive,
  watch,
  onUnmounted,
  getCurrentInstance
} from "vue";
import apiMine from "@/api/api/apiMine.js";
import message from "@/components/functionCallComponent/message/message.js";
import useUserDataStore from "@/store/userDataStore";
import { useRouter } from "vue-router";
const router = useRouter();
const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const { $$t } = globalProperties?.$i18n
const userDataStore = useUserDataStore();
const emits = defineEmits(["update:visible"]);
const props = defineProps({
  orderId: {
    type: Number,
    default: 0,
  },
  visible: {
    type: Boolean,
    default: false,
  },
  remove: {
    type: Function,
    default: null,
  },
  paySuccess: {
    type: Function,
    default: null,
  },
});

const state = ref(5);
const isLoading = ref(false);
let intervalId = null;
let pollCount = 0; // 轮询计数器
const MAX_POLL_COUNT = 9; // 最大轮询次数
const POLL_INTERVAL = 3000; // 轮询间隔3秒
let orifinProduct = {};

const renderData = reactive({
  visible: props.visible,
});

// 监听visible变化
watch(
  () => props.visible,
  (val) => {
    renderData.visible = val;
  }
);

// 关闭对话框时清理
watch(
  () => renderData.visible,
  (val) => {
    if (!val) {
      clearPolling();
      props.remove?.();
      emits("update:visible", val);
    }
  }
);

// 清理轮询
const clearPolling = () => {
  if (intervalId) {
    clearInterval(intervalId);
    intervalId = null;
    pollCount = 0; // 重置计数器
  }
};

const closeDialog = () => {
  renderData.visible = false;
};

const goUrl = () => {
  closeDialog()
  if (orifinProduct.category == "normal" && orifinProduct.p_group == "lora") {
    router
      .replace({
        name: "create",
        query: {
          is_create_model: 1,
        },
      })
      .then(() => {
        router.go(0);
      });

  } else if (
    orifinProduct.category == "normal" &&
    orifinProduct.p_group != "lora"
  ) {
    userDataStore.getUserInfo();
    userDataStore.refreshUserAccount();
  } else if (orifinProduct.category == "subscription") {
    router
      .replace({
        name: "subscribe",
      })
      .then(() => {
        router.go(0); // 相当于 location.reload()
      });

  }
};

const checkPay = () => {
  isLoading.value = true;
  clearPolling();
  getResult();
  intervalId = setInterval(() => {
    if (pollCount >= MAX_POLL_COUNT) {
      clearPolling();
      closeDialog();
      return;
    }
    getResult();
  }, POLL_INTERVAL);
};

const getResult = () => {
  pollCount++; // 每次查询计数

  apiMine
    .mineOrderDetail({
      order_id: props.orderId,
    })
    .then((res) => {
      if (res.code == 200) {
        const {
          data: { state, product },
        } = res;
        orifinProduct = product;
        if (state == 4) {
          isLoading.value = false;
          clearPolling();
          message.success({
            position: "top",
            content: "付款成功",
            duration: 2000,
          });
          goUrl();
        } else if (pollCount >= MAX_POLL_COUNT) {
          isLoading.value = false;
          message.warning({
            position: "top",
            content: "未检测到支付成功状态",
            duration: 2000,
          });
          closeDialog();
        }
      }
    })
    .catch((err) => {
      isLoading.value = false;
      console.error("查询支付状态失败:", err);
      closeDialog();
      if (pollCount >= MAX_POLL_COUNT) {
        clearPolling();
      }
    });
};

// 组件卸载时清理
onUnmounted(() => {
  clearPolling();
});
</script>

<style lang="scss">
.confirm-pay-dialog {
  .pay-result {
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    .text {
      font-size: 36px;
      font-weight: bold;
      line-height: 52px;
      text-align: center;
      letter-spacing: 0em;
    }
    .loading {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .icon-box {
        color: #94adff;
        width: 96px;
        height: 96px;
        background: rgba(148, 173, 255, 0.2);
        backdrop-filter: blur(50px);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        margin-bottom: 32px;
        .icon {
          width: 30px;
          height: 30px;
          background-image: url("@/assets/img/payment/icon-cycle.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          background-position: center;
          animation: rotate-animation 3s infinite linear;
        }
      }
    }
    .fail {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .btn-box {
        padding-top: 30px;
        .btn {
          width: 400px;
          height: 84px;
          background: #94adff;
          backdrop-filter: blur(50px);
          font-size: 24px;
          font-weight: 500;
          line-height: normal;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 20px;
          border-radius: 42px;
          margin-bottom: 20px;
        }
      }
    }
    @media screen and (max-width: 768px) {
      .text {
        font-size: 16px;
        font-weight: bold;
        line-height: 36px;
        text-align: center;
      }
      .fail {
        .btn-box {
          .btn {
            width: 240px;
            height: 46px;
            font-size: 20px;
          }
        }
        .loading-placeholder {
          @keyframes spin {
            to {
              transform: rotate(360deg);
            }
          }
          img {
            animation: spin 1.5s linear infinite;
            width: 20px;
            height: 20px;
          }
        }
      }
    }
  }
}
</style>